import UpdateBigQuerySecretForm from './UpdateBigQuerySecretForm';

export default function BigQuerySettings() {
  return (
    <div className="mt-6">
      <UpdateBigQuerySecretForm />
    </div>
  );
}
